import classNames from 'classnames'
import styles from './styles.module.scss'

type Variant =
  | 'primary-inline' // 2 CTAs inline
  | 'primary-stacked' // 2 CTAs stacked
  | 'secondary-stacked'
  | 'secondary-inline'

type FormButtonGroupProps = {
  variant: Variant
  classes?: string

  primaryCta: React.ReactNode
  secondaryCta?: React.ReactNode
  children?: React.ReactNode // e.g. a third button if needed
}

export default function FormButtonGroup({
  variant,
  classes,
  primaryCta,
  secondaryCta,
  children
}: FormButtonGroupProps) {
  const isStacked =
    variant === 'primary-stacked' || variant === 'secondary-stacked'
  const containerClasses = classNames(
    styles.FormButtonGroup,
    styles[variant],
    classes,
    {
      [styles.stacked]: isStacked
    }
  )

  return (
    <div className={containerClasses}>
      <div className={styles.FormButtonGroup__ctas}>
        {secondaryCta}
        {primaryCta}
      </div>

      {children && (
        <div className={styles.FormButtonGroup__copy}>{children}</div>
      )}
    </div>
  )
}
